import React from "react"
import FeaturedButton from "./FeaturedButton"

const LearnMoreBox = ({ body, id }) => {
  return (
    <div className="box">
      <div className="has-text-centered">
        <p className="has-text-weight-bold is-size-5-mobile is-size-4-tablet is-size-3-widescreen">
          {body}
        </p>
        <FeaturedButton id={id} />
      </div>
    </div>
  )
}

export default LearnMoreBox
